module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"valid_message_length":"(유효글자: {0}자)"}}')
  delete Component.options._Ctor
}
